import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
import router from "../../router/index";

const state = {
  showRejectAcceptButton: false,
  reportTypes: null,
  listingDetailsFront:null,
  listingInteresting: [],
  listingSellerDetail: []
};
const getters = {
  listingDetail: (state) => state.listingDetail
};

const actions = {
  [actionType.SHOW_REJECT_ACCEPT_BUTTON]: function ({ commit }, params) {
    commit(mutationType.SET_SHOW_REJECT_ACCEPT_BUTTON, params);
  },
  [actionType.GET_REPORT_TYPE]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get('/report-type', {
        params: {
          take: params.take,
          page: params.page,
        },
      }).then(result => {
        commit(mutationType.REPORT_TYPE, {
          data: result.data.data,
          type: params.type
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_LISTING_DETAILS_FOR_FRONT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/listings/detail/${params.id}`, {
        params: params
      }).then(result => {
        commit(mutationType.LISTING_DETAILS_FOR_FRONT, {
          data: result.data.data,
          type: params.type
        })
        resolve(result)
      })
      .catch(error => {
        router.push({name: "Home"})
        reject(error);
      })
    });
  },
  [actionType.GET_LISTING_INTERESTINGS]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/listings/interestings`, {
        params: {
          take: params.take,
          page: params.page
        },
      }).then(result => {
        if(result.data.data) {
          commit(mutationType.SET_LISTING_INTERESTINGS, result.data.data)
        }
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_LISTING_SELLER_DETAIL_ORTHER]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/listings/others/${params.listing_id}`, {
        params: {
          take: params.take,
          page: params.page,
          user_id: params.user_id
        },
      }).then(result => {
        commit(mutationType.SET_LISTING_SELLER_DETAIL, result.data.data)
      })
        .catch(error => reject(error));
    });
  },
  [actionType.CREATE_REPORT_LISTING_DETAIL]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`/user-reports-listing`, params)
      .then(result => {
        resolve(result)
      })
        .catch(error => reject(error));
    });
  },
  [actionType.CREATE_MESSAGE_LISTING_DETAIL]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`/user-messages`, params)
      .then(result => {
        resolve(result)
      })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [mutationType.SET_SHOW_REJECT_ACCEPT_BUTTON](state, showRejectAcceptButton) {
    state.showRejectAcceptButton = showRejectAcceptButton;
  },
  [mutationType.REPORT_TYPE]: function (state, data) {
    state.reportTypes = data.data;
  },
  [mutationType.LISTING_DETAILS_FOR_FRONT]: function (state, data) {
    state.listingDetailsFront = data.data;
  },
  [mutationType.SET_LISTING_INTERESTINGS]: function (state, data) {
    state.listingInteresting = data;
  },
  [mutationType.SET_LISTING_SELLER_DETAIL]: function (state, data) {
    state.listingSellerDetail = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}